import React, { useState } from "react";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";

const UserServiceModal = ({ editData, addUser, editUser }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^\+?[1-9]\d{9,14}$/;

  const [userData, setUsersData] = useState({
    email: editData.email || "",
    name: editData.name || "",
    mobile: editData.mobile || "",
    password: editData.password || "",
    disable_welcome_email: true,
    disable_password_email: true
  });
  const [errors, setErrors] = useState({
    email: "",
    mobile: ""
  });

  const handleUserData = (e) => {
    if (errors[e.target.name]) {
      setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    }
    setUsersData({ ...userData, [e.target.name]: e.target.value });
  };

  const validateUserData = () => {
    const nextErrors = {
      email: "",
      mobile: ""
    };

    const trimmedEmail = userData.email.trim();
    const trimmedMobile = userData.mobile.trim();

    if (editData.email.length === 0 && trimmedEmail && !emailRegex.test(trimmedEmail)) {
      nextErrors.email = "Enter a valid email address";
    }

    if (trimmedMobile && !mobileRegex.test(trimmedMobile)) {
      nextErrors.mobile = "Enter a valid mobile number";
    }

    setErrors(nextErrors);
    return !nextErrors.email && !nextErrors.mobile;
  };

  const handleSubmit = () => {
    if (!validateUserData()) return;

    if (editData.email.length === 0) {
      addUser(userData);
    } else {
      editUser({ ...editData, ...userData }, editData.id);
    }
  };

  return (
    <div>
      <div className="builder_form">
        <Input label="Name" placeholder="Enter Name" name="name" value={userData.name} onChange={handleUserData} />
        {editData.email.length === 0 && (
          <>
            <Input
              label="Email"
              type="email"
              placeholder="Enter Email"
              name="email"
              //
              value={userData.email}
              onChange={handleUserData}
              error={errors.email}
            />
          </>
        )}
        <Input
          label="Mobile"
          placeholder="Enter Mobile Number"
          name="mobile"
          value={userData.mobile}
          onChange={handleUserData}
          error={errors.mobile}
        />
        {editData.email.length === 0 && (
          <>
            <Input
              label="Password"
              placeholder="Enter Password"
              name="password"
              value={userData.password}
              onChange={handleUserData}
            />
          </>
        )}
        {editData.email.length === 0 ? (
          <Button onClick={handleSubmit}>+ Add User</Button>
        ) : (
          <Button onClick={handleSubmit}>Edit User</Button>
        )}
      </div>
    </div>
  );
};

export default UserServiceModal;
